import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';

interface CommissionTier {
  tier: string;
  minClients: number;
  minVolume: number;
  commissionRate: number;
  benefits: string[];
}

interface CommissionTiersProps {
  commissionTiers: CommissionTier[];
  currentTier?: CommissionTier;
}

const CommissionTiers = ({
  commissionTiers,
  currentTier,
}: CommissionTiersProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Commission Tiers</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {commissionTiers.map(tier => (
            <div
              key={tier.tier}
              className={`p-4 border rounded-lg ${
                tier.tier === currentTier?.tier
                  ? 'border-yellow-500 bg-yellow-50'
                  : 'border-gray-200'
              }`}
            >
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <h3 className="font-semibold">{tier.tier}</h3>
                  {tier.tier === currentTier?.tier && (
                    <Badge variant="default" className="text-xs">
                      Current
                    </Badge>
                  )}
                </div>
                <span className="text-lg font-bold text-green-600">
                  {tier.commissionRate}%
                </span>
              </div>
              <div className="grid grid-cols-2 gap-4 text-sm text-gray-600 mb-3">
                <div>
                  <span className="font-medium">Min Clients:</span>{' '}
                  {tier.minClients}
                </div>
                <div>
                  <span className="font-medium">Min Volume:</span> $
                  {tier.minVolume.toLocaleString()}
                </div>
              </div>
              <div className="flex flex-wrap gap-1">
                {tier.benefits.map((benefit, index) => (
                  <Badge key={index} variant="outline" className="text-xs">
                    {benefit}
                  </Badge>
                ))}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default CommissionTiers;
